'use client';

import { c as _c } from "react/compiler-runtime";
import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { type FC, type ReactElement, useId, useMemo, useState } from 'react';
import Point from '../../../../../public/images/wallet-points.png';
interface PointsToTokensCardProps {
  className?: string;
  points: number;
  tokens: number;
  imageSrc?: string;
  title: string;
  subtitle: string;
}
const cvaPointsToTokensCard = cva(['PointsToTokensCard', 'relative flex w-full justify-between overflow-hidden', 'rounded-2xl border border-[#4345644D] bg-[#000000] lg:bg-[#0000004D] text-[#E8E8E8] backdrop-blur-sm']);
export const PointsToTokensCard: FC<PointsToTokensCardProps> = t0 => {
  const $ = _c(53);
  const {
    className,
    points,
    tokens,
    imageSrc
  } = t0;
  const t = useTranslations("LeaderBoard.Points_Card");
  let t1;
  if ($[0] !== points) {
    t1 = new Intl.NumberFormat("en-US").format(points);
    $[0] = points;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedPoints = t1;
  const num = tokens;
  let t2;
  if ($[2] !== num) {
    t2 = num.toLocaleString("en-US", {
      useGrouping: true,
      roundingMode: "floor"
    } as Intl.NumberFormatOptions).split(".");
    $[2] = num;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const fractionDigits = 10 - t2[0].length - 1;
  let t3;
  if ($[4] !== fractionDigits || $[5] !== num) {
    const fixed = num.toLocaleString("en-US", {
      maximumFractionDigits: fractionDigits,
      useGrouping: true,
      roundingMode: "floor"
    } as Intl.NumberFormatOptions);
    t3 = fixed.split(".");
    $[4] = fractionDigits;
    $[5] = num;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const [intPart, fracPart] = t3;
  let t4;
  if ($[7] !== fracPart || $[8] !== intPart) {
    t4 = {
      tokensInt: intPart,
      tokensFrac: fracPart
    };
    $[7] = fracPart;
    $[8] = intPart;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    tokensInt,
    tokensFrac
  } = t4;
  const [videoLoaded, setVideoLoaded] = useState(false);
  const titleId = useId();
  let t5;
  if ($[10] !== className) {
    t5 = clsx(cvaPointsToTokensCard(), className);
    $[10] = className;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("Earned");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6 || $[15] !== titleId) {
    t7 = <h3 id={titleId} className="font-semibold font-montserrat text-[12px] uppercase leading-[1] 2md:text-[22px]">{t6}</h3>;
    $[14] = t6;
    $[15] = titleId;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== formattedPoints || $[18] !== points) {
    t8 = <data value={points} className="bold mt-1 text-[48px] font-semibold leading-[0.9] 2md:text-[62px]">{formattedPoints}</data>;
    $[17] = formattedPoints;
    $[18] = points;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("Get");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <p className="mt-[34px] text-[12px] font-semibold font-montserrat uppercase md:mt-8 2md:text-[22px] leading-[1]">{" "}{t9}</p>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== tokens) {
    t11 = tokens.toFixed(2);
    $[24] = tokens;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== tokens) {
    t12 = tokens.toFixed(2);
    $[26] = tokens;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== tokensInt) {
    t13 = <span className="text-[48px] leading-[0.9] 2md:text-[56px]">{tokensInt}</span>;
    $[28] = tokensInt;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== tokensFrac) {
    t14 = tokensFrac && <span className="mb-1 font-primary text-[28px] font-semibold 2md:mb-[28px]">.{tokensFrac}</span>;
    $[30] = tokensFrac;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t11 || $[33] !== t12 || $[34] !== t13 || $[35] !== t14) {
    t15 = <data value={t11} aria-label={t12} className="mt-1 font-secondary font-semibold leading-[0.9]">{t13}{t14}</data>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t10 || $[38] !== t15 || $[39] !== t7 || $[40] !== t8) {
    t16 = <div className="z-[1] flex flex-1 flex-col px-5 py-6 2md:px-8 2md:py-8">{t7}{t8}{t10}{t15}</div>;
    $[37] = t10;
    $[38] = t15;
    $[39] = t7;
    $[40] = t8;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  const t17 = imageSrc ?? Point;
  const t18 = "object-cover object-right " + (!videoLoaded ? "" : "hidden");
  let t19;
  if ($[42] !== t17 || $[43] !== t18) {
    t19 = <Image src={t17} alt="" fill={true} sizes="(min-width: 1536px) 320px, 260px" className={t18} priority={true} />;
    $[42] = t17;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <video autoPlay={true} muted={true} loop={true} src="/images/points-video.webm" playsInline={true} onLoadedData={() => setVideoLoaded(true)} className="pointer-events-none absolute right-0 top-0 select-none object-contain block h-[calc(100%+16px)] -mr-8 -mt-1 -mb-3 -rotate-6" />;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t19) {
    t21 = <div className="pointer-events-none absolute inset-y-0 right-0 h-full w-[260px] 2md:w-[320px]" aria-hidden="true">{t19}{t20}</div>;
    $[46] = t19;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t16 || $[49] !== t21 || $[50] !== t5 || $[51] !== titleId) {
    t22 = <article className={t5} aria-labelledby={titleId}>{t16}{t21}</article>;
    $[48] = t16;
    $[49] = t21;
    $[50] = t5;
    $[51] = titleId;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  return t22;
};
PointsToTokensCard.displayName = 'PointsToTokensCard';
export type { PointsToTokensCardProps };